@if (isLoading()) {
  <lib-overlay-loader />
} @else {
  <div
    class="flex justify-between items-center pt-2xl pb-lg border-b border-neutral-200">
    <div class="text-lg font-semibold text-neutral-900">
      {{
        mode() === 'edit'
          ? ('workflow_details_table_add_resource_screen_edit_title'
            | transloco)
          : ('workflow_details_table_add_resource_screen_title' | transloco)
      }}
    </div>

    <div class="flex gap-lg">
      <button
        id="cancel"
        class="px-lg py-sm rounded-md text-primary-600 bg-white text-sm font-medium cursor-pointer"
        type="button"
        [routerLink]="[
          '/workflow/permissions/permission-details' | tenantPath: 'admin',
          flowTemplateId(),
          'view',
        ]">
        {{
          mode() === 'edit'
            ? ('workflow_details_table_add_member_screen_cancel_edits_button'
              | transloco)
            : ('workflow_details_table_add_member_screen_cancel_button'
              | transloco)
        }}
      </button>
      <button
        id="save"
        class="px-lg py-sm rounded-md text-white bg-primary-500 text-sm font-medium border-none cursor-pointer"
        type="submit"
        (click)="save()">
        {{
          mode() === 'edit'
            ? ('workflow_details_table_add_member_screen_save_edits_button'
              | transloco)
            : ('workflow_details_table_add_member_screen_save_button'
              | transloco)
        }}
      </button>
    </div>
  </div>

  <form [formGroup]="memberPermissionsForm()">
    <div
      class="permissions-table mt-lg [&_.placeholder-container]:!justify-start [&_.placeholder-container]:!gap-sm">
      <table
        class="w-full border-collapse [&_th]:py-md [&_th]:px-xl [&_th]:border-b [&_th]:border-e [&_th]:border-neutral-200 [&_th:first-child]:w-[2.25rem] [&_th:last-child]:w-[3.5rem] [&_th:last-child]:border-e-0 [&_th:last-child]:m-0 [&_td]:px-xl [&_td]:border-b [&_td]:border-neutral-200">
        <thead class="bg-neutral-50">
          <tr class="text-xs text-neutral-700 font-semibold">
            <th class="text-start"></th>
            <th class="text-start w-[15rem]">
              {{
                'workflow_details_table_add_member_screen_resource_type_label'
                  | transloco
              }}
            </th>
            <th class="text-start w-[15rem]">
              {{
                'workflow_details_table_add_member_screen_resource_label'
                  | transloco
              }}
            </th>
            <th>
              {{
                'workflow_details_table_add_member_screen_view_workflow_label'
                  | transloco
              }}
            </th>
            <th>
              {{
                'workflow_details_table_add_member_screen_trigger_new_requests_label'
                  | transloco
              }}
            </th>
            <th>
              {{
                'workflow_details_table_add_member_screen_view_all_requests_label'
                  | transloco
              }}
            </th>

            <th>
              {{
                'workflow_details_table_add_member_screen_hold_resume_label'
                  | transloco
              }}
            </th>

            <th>
              {{
                'workflow_details_table_add_member_screen_archive_label'
                  | transloco
              }}
            </th>
            @if (isScheduleWorkflowToRunOnceEnabled()) {
              <th>
                {{
                  'workflow_details_table_add_member_screen_view_workflow_schedules_label'
                    | transloco
                }}
              </th>
              <th>
                {{
                  'workflow_details_table_add_member_screen_add_workflow_schedule_label'
                    | transloco
                }}
              </th>
              <th>
                {{
                  'workflow_details_table_add_member_screen_edit_workflow_schedule_label'
                    | transloco
                }}
              </th>
              <th>
                {{
                  'workflow_details_table_add_member_screen_cancel_workflow_schedule_label'
                    | transloco
                }}
              </th>
            }
            <th></th>
          </tr>
        </thead>
        <tbody formArrayName="members">
          @for (member of membersFormArray.controls; track $index) {
            <tr [formGroupName]="$index">
              <td class="text-center bg-neutral-50 text-sm">
                {{ $index + 1 }}
              </td>
              <td>
                @if (getMemberControl($index, 'model_type').value) {
                  <div class="flex gap-md items-center my-sm">
                    <div>
                      {{
                        'workflow_details_table_add_member_screen_{' +
                          getMemberControl($index, 'model_type').value +
                          '}_label' | transloco
                      }}
                    </div>
                  </div>
                } @else {
                  <div class="resource-type-select">
                    <lib-select
                      [inputFormControlName]="'model_type'"
                      id="model_type + $index"
                      name="model_type"
                      [required]="true"
                      [options]="assigneeTypeOptions()"
                      [selectedKeyName]="'label'"
                      [selectedKeyValue]="'value'"
                      [placeholder]="
                        'workflow_details_table_add_member_screen_select_type_placeholder'
                          | transloco
                      "
                      [hasSmallGap]="true"
                      [inputClass]="'border-none font-medium !p-0 !text-xs focus:!shadow-none focus:!outline-none focus:!border-none'"
                      [dropdownClass]="'!w-[10.8125rem]'"
                      (changeOption)="selectAssignableType($event, $index)" />
                  </div>
                }
              </td>
              <td>
                @if (
                  getMemberControl($index, 'model_id').value &&
                  selectedUsers &&
                  selectedUsers[$index]
                ) {
                  <div class="flex gap-md items-center my-sm">
                    <lib-avatar
                      [fullName]="selectedUsers[$index]?.label"
                      [borderRadius]="'rounded-full'"
                      [img]="selectedUsers[$index]?.image?.url"
                      class="!ms-0 !border-none" />

                    <div>
                      <p class="text-xs font-medium text-neutral-900">
                        {{ selectedUsers[$index]?.label | truncate: 50 }}
                      </p>
                    </div>
                  </div>
                } @else {
                  <div>
                    <div class="flex flex-col gap-x-sm w-25rem">
                      @if (
                        getMemberControl($index, 'model_type').value !==
                        'legal_entity'
                      ) {
                        <div
                          class="resource-select [&_.dropdown-list]:!w-[17.6875rem]">
                          <lib-customized-dropdown
                            [id]="'model_id'"
                            [inputFormControlName]="'model_id'"
                            [name]="'model_id'"
                            [inputClass]="'border-none font-medium !p-0 !text-xs focus:!shadow-none focus:!outline-none focus:!border-none'"
                            [required]="true"
                            [hasSmallGap]="true"
                            [placeholder]="
                              assigneeSelectDependency()[$index].placeholder
                            "
                            [apiUrl]="assigneeSelectDependency()[$index].api"
                            [selectedOption]="
                              assigneeSelectDependency()[$index].selectedOption
                            "
                            [filters]="
                              assigneeSelectDependency()[$index].filters
                            "
                            [searchLabel]="
                              assigneeSelectDependency()[$index].searchLabel
                            "
                            [searchPlaceholder]="
                              assigneeSelectDependency()[$index]
                                .searchPlaceholder || ''
                            "
                            [disabled]="
                              !getMemberControl($index, 'model_type').value
                            "
                            (changeOption)="selectResource($event, $index)" />
                        </div>
                      } @else {
                        <lib-paginated-select
                          [id]="'model_id'"
                          [inputFormControlName]="'model_id'"
                          [name]="'name'"
                          [inputClass]="'border-none font-medium !p-0 !text-xs focus:!shadow-none focus:!outline-none focus:!border-none'"
                          [required]="true"
                          [hasSmallGap]="true"
                          [placeholder]="
                            assigneeSelectDependency()[$index].placeholder
                          "
                          [apiUrl]="assigneeSelectDependency()[$index].api"
                          [selectedOption]="
                            assigneeSelectDependency()[$index].selectedOption
                          "
                          (changeOption)="selectResource($event, $index)"
                          [noDataLabel]="
                            'user_dropdown_input_no_data_label' | transloco
                          " />
                      }
                    </div>
                  </div>
                }
              </td>
              <td class="py-md">
                <div class="flex items-center justify-center">
                  <lib-checkbox
                    width="1.5rem"
                    height="1.5rem"
                    iconWidth="0.8125rem"
                    iconHeight="0.625rem"
                    [hasMarginEnd]="false"
                    [formGroup]="getMemberFormGroup($index)"
                    [inputFormControlName]="'view'"
                    [singleCheckBox]="true"
                    [id]="'view' + $index"
                    [disabled]="isViewPermissionDisabled($index)" />
                </div>
              </td>
              <td>
                <div class="flex items-center justify-center">
                  <lib-checkbox
                    width="1.5rem"
                    height="1.5rem"
                    iconWidth="0.8125rem"
                    iconHeight="0.625rem"
                    [hasMarginEnd]="false"
                    [formGroup]="getMemberFormGroup($index)"
                    [inputFormControlName]="'trigger'"
                    [singleCheckBox]="true"
                    [id]="'trigger' + $index"
                    [disabled]="isTriggerPermissionDisabled($index)" />
                </div>
              </td>
              <td>
                <div class="flex items-center justify-center">
                  <lib-checkbox
                    width="1.5rem"
                    height="1.5rem"
                    iconWidth="0.8125rem"
                    iconHeight="0.625rem"
                    [hasMarginEnd]="false"
                    [formGroup]="getMemberFormGroup($index)"
                    [inputFormControlName]="'view_all'"
                    [singleCheckBox]="true"
                    [id]="'view_all' + $index" />
                </div>
              </td>

              <td>
                <div class="flex items-center justify-center">
                  <lib-checkbox
                    width="1.5rem"
                    height="1.5rem"
                    iconWidth="0.8125rem"
                    iconHeight="0.625rem"
                    [hasMarginEnd]="false"
                    [formGroup]="getMemberFormGroup($index)"
                    [inputFormControlName]="'hold'"
                    [singleCheckBox]="true"
                    [id]="'hold' + $index" />
                </div>
              </td>

              <td>
                <div class="flex items-center justify-center">
                  <lib-checkbox
                    width="1.5rem"
                    height="1.5rem"
                    iconWidth="0.8125rem"
                    iconHeight="0.625rem"
                    [hasMarginEnd]="false"
                    [formGroup]="getMemberFormGroup($index)"
                    [inputFormControlName]="'archive'"
                    [singleCheckBox]="true"
                    [id]="'archive' + $index" />
                </div>
              </td>
              @if (isScheduleWorkflowToRunOnceEnabled()) {
                <td>
                  <div class="flex items-center justify-center">
                    <lib-checkbox
                      width="1.5rem"
                      height="1.5rem"
                      iconWidth="0.8125rem"
                      iconHeight="0.625rem"
                      [hasMarginEnd]="false"
                      [formGroup]="getMemberFormGroup($index)"
                      [inputFormControlName]="'view_workflow_schedule'"
                      [singleCheckBox]="true"
                      [id]="'view_workflow_schedule' + $index"
                      [disabled]="isViewWorkflowScheduleDisabled($index)" />
                  </div>
                </td>
                <td>
                  <div class="flex items-center justify-center">
                    <lib-checkbox
                      width="1.5rem"
                      height="1.5rem"
                      iconWidth="0.8125rem"
                      iconHeight="0.625rem"
                      [hasMarginEnd]="false"
                      [formGroup]="getMemberFormGroup($index)"
                      [inputFormControlName]="'add_workflow_schedule'"
                      [singleCheckBox]="true"
                      [id]="'add_workflow_schedule' + $index" />
                  </div>
                </td>
                <td>
                  <div class="flex items-center justify-center">
                    <lib-checkbox
                      width="1.5rem"
                      height="1.5rem"
                      iconWidth="0.8125rem"
                      iconHeight="0.625rem"
                      [hasMarginEnd]="false"
                      [formGroup]="getMemberFormGroup($index)"
                      [inputFormControlName]="'edit_workflow_schedule'"
                      [singleCheckBox]="true"
                      [id]="'edit_workflow_schedule' + $index" />
                  </div>
                </td>
                <td>
                  <div class="flex items-center justify-center">
                    <lib-checkbox
                      width="1.5rem"
                      height="1.5rem"
                      iconWidth="0.8125rem"
                      iconHeight="0.625rem"
                      [hasMarginEnd]="false"
                      [formGroup]="getMemberFormGroup($index)"
                      [inputFormControlName]="'cancel_workflow_schedule'"
                      [singleCheckBox]="true"
                      [id]="'cancel_workflow_schedule' + $index" />
                  </div>
                </td>
              }
              <td>
                @if (membersFormArray.length > 1) {
                  <a
                    class="text-destructive-500 bg-transparent border-none cursor-pointer block"
                    (click)="removeResource($index)">
                    <lib-remove-item-icon
                      [iconClass]="'size-6 text-destructive-500'" />
                  </a>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>

      <!-- Add Member Button -->
      @if (mode() === 'add') {
        @let disabledAddMember =
          !membersFormArray.controls[membersFormArray.length - 1].get(
            'model_type'
          )?.value ||
          !membersFormArray.controls[membersFormArray.length - 1].get(
            'model_id'
          )?.value;
        <button
          type="button"
          (click)="addMember()"
          [disabled]="disabledAddMember"
          [class.opacity-30]="disabledAddMember"
          class="flex items-center gap-sm text-primary-600 bg-transparent border-none cursor-pointer text-sm font-medium mt-2xl py-sm px-lg">
          <lib-add-icon [iconClass]="'size-5 text-primary-600'" />

          {{
            'workflow_details_table_add_member_screen_add_resource_button_label'
              | transloco
          }}
        </button>
      }
    </div>
  </form>
}
